export default {
  '--black': '#1e1e1e',
  '--white': '#ffffff',

  '--pick-color': '#82b1ff',

  '--red-opacity': 'rgba(230, 93, 83, 0.8)',
  '--pink-opacity': 'rgba(205, 73, 118, 0.8)',
  '--blue-opacity': 'rgba(75, 154, 216, 0.8)',
  '--brown-opacity': 'rgba(120, 97, 88, 0.8)',
  '--green-opacity': 'rgba(94, 173, 97, 0.8)',
  '--amber-opacity': 'rgba(232, 185, 46, 0.8)',
  '--orange-opacity': 'rgba(238,157,43,.8)',
  '--purple-opacity': 'rgba(147, 71, 160, 0.8)',
  '--black-opacity': 'rgba(50, 50, 50, 0.7)',

  '--red-20': 'hsl(0, 65%, 98%)',
  '--red-50': 'hsl(0, 65%, 95%)',
  '--red-100': 'hsl(0, 65%, 89%)',
  '--red-200': 'hsl(0, 65%, 81%)',
  '--red-300': 'hsl(0, 65%, 74%)',
  '--red-400': 'hsl(0, 65%, 67%)',
  '--red-500': 'hsl(0, 65%, 60%)',
  '--red-600': 'hsl(0, 65%, 53%)',
  '--red-700': 'hsl(0, 65%, 46%)',
  '--red-800': 'hsl(0, 65%, 39%)',
  '--red-900': 'hsl(0, 65%, 32%)',

  '--pink-50': 'hsl(340, 60%, 93%)',
  '--pink-100': 'hsl(340, 60%, 89%)',
  '--pink-200': 'hsl(340, 60%, 81%)',
  '--pink-300': 'hsl(340, 60%, 72%)',
  '--pink-400': 'hsl(340, 60%, 63%)',
  '--pink-500': 'hsl(340, 60%, 55%)',
  '--pink-600': 'hsl(340, 60%, 50%)',
  '--pink-700': 'hsl(340, 60%, 45%)',
  '--pink-800': 'hsl(340, 60%, 39%)',
  '--pink-900': 'hsl(340, 60%, 32%)',

  '--purple-50': 'hsl(290, 37%, 92%)',
  '--purple-100': 'hsl(290, 37%, 86%)',
  '--purple-200': 'hsl(290, 37%, 74%)',
  '--purple-300': 'hsl(290, 37%, 62%)',
  '--purple-400': 'hsl(290, 37%, 52%)',
  '--purple-500': 'hsl(290, 37%, 45%)',
  '--purple-600': 'hsl(290, 37%, 38%)',
  '--purple-700': 'hsl(290, 37%, 33%)',
  '--purple-800': 'hsl(290, 37%, 29%)',
  '--purple-900': 'hsl(290, 37%, 25%)',

  '--blue-50': 'hsl(206, 64%, 92%)',
  '--blue-100': 'hsl(206, 64%, 85%)',
  '--blue-200': 'hsl(206, 64%, 78%)',
  '--blue-300': 'hsl(206, 64%, 70%)',
  '--blue-400': 'hsl(206, 64%, 64%)',
  '--blue-500': 'hsl(206, 64%, 57%)',
  '--blue-600': 'hsl(206, 64%, 50%)',
  '--blue-700': 'hsl(206, 64%, 43%)',
  '--blue-800': 'hsl(206, 64%, 36%)',
  '--blue-900': 'hsl(206, 64%, 30%)',

  '--cyan-50': 'hsl(186, 55%, 92%)',
  '--cyan-100': 'hsl(186, 55%, 85%)',
  '--cyan-200': 'hsl(186, 55%, 75%)',
  '--cyan-300': 'hsl(186, 55%, 65%)',
  '--cyan-400': 'hsl(186, 55%, 55%)',
  '--cyan-500': 'hsl(186, 55%, 48%)',
  '--cyan-600': 'hsl(186, 55%, 41%)',
  '--cyan-700': 'hsl(206, 64%, 43%)',
  '--cyan-800': 'hsl(186, 55%, 36%)',
  '--cyan-900': 'hsl(186, 55%, 27%)',

  '--green-50': 'hsl(120, 33%, 94%)',
  '--green-100': 'hsl(120, 33%, 87%)',
  '--green-200': 'hsl(120, 33%, 77%)',
  '--green-300': 'hsl(120, 33%, 68%)',
  '--green-400': 'hsl(120, 33%, 59%)',
  '--green-500': 'hsl(120, 33%, 52%)',
  '--green-600': 'hsl(120, 33%, 47%)',
  '--green-700': 'hsl(120, 33%, 41%)',
  '--green-800': 'hsl(120, 33%, 35%)',
  '--green-900': 'hsl(120, 33%, 30%)',

  '--yellow-50': 'hsl(55, 85%, 93%)',
  '--yellow-100': 'hsl(55, 85%, 89%)',
  '--yellow-200': 'hsl(55, 85%, 81%)',
  '--yellow-300': 'hsl(55, 85%, 74%)',
  '--yellow-400': 'hsl(55, 85%, 67%)',
  '--yellow-500': 'hsl(55, 85%, 60%)',
  '--yellow-600': 'hsl(51, 85%, 55%)',
  '--yellow-700': 'hsl(47, 85%, 50%)',
  '--yellow-800': 'hsl(41, 85%, 50%)',
  '--yellow-900': 'hsl(35, 85%, 50%)',

  '--amber-50': 'hsl(45, 85%, 93%)',
  '--amber-100': 'hsl(45, 85%, 89%)',
  '--amber-200': 'hsl(45, 85%, 81%)',
  '--amber-300': 'hsl(45, 85%, 72%)',
  '--amber-400': 'hsl(45, 85%, 63%)',
  '--amber-500': 'hsl(45, 85%, 55%)',
  '--amber-600': 'hsl(45, 85%, 50%)',
  '--amber-700': 'hsl(40, 85%, 50%)',
  '--amber-800': 'hsl(34, 85%, 50%)',
  '--amber-900': 'hsl(27, 85%, 50%)',

  '--orange-50': 'hsl(35, 85%, 93%)',
  '--orange-100': 'hsl(35, 85%, 89%)',
  '--orange-200': 'hsl(35, 85%, 81%)',
  '--orange-300': 'hsl(35, 85%, 72%)',
  '--orange-400': 'hsl(35, 85%, 63%)',
  '--orange-500': 'hsl(35, 85%, 55%)',
  '--orange-600': 'hsl(35, 85%, 50%)',
  '--orange-700': 'hsl(31, 85%, 50%)',
  '--orange-800': 'hsl(27, 85%, 48%)',
  '--orange-900': 'hsl(23, 85%, 46%)',

  '--brown-50': 'hsl(15, 20%, 93%)',
  '--brown-100': 'hsl(15, 20%, 87%)',
  '--brown-200': 'hsl(15, 20%, 72%)',
  '--brown-300': 'hsl(15, 20%, 61%)',
  '--brown-400': 'hsl(15, 20%, 50%)',
  '--brown-500': 'hsl(15, 20%, 40%)',
  '--brown-600': 'hsl(15, 20%, 35%)',
  '--brown-700': 'hsl(15, 20%, 30%)',
  '--brown-800': 'hsl(15, 20%, 25%)',
  '--brown-900': 'hsl(15, 20%, 20%)',

  '--grey-50': 'hsl(0, 0%, 98%)',
  '--grey-100': 'hsl(0, 0%, 96%)',
  '--grey-200': 'hsl(0, 0%, 93%)',
  '--grey-300': 'hsl(0, 0%, 88%)',
  '--grey-400': 'hsl(0, 0%, 74%)',
  '--grey-500': 'hsl(0, 0%, 62%)',
  '--grey-600': 'hsl(0, 0%, 46%)',
  '--grey-700': 'hsl(0, 0%, 38%)',
  '--grey-800': 'hsl(0, 0%, 26%)',
  '--grey-900': 'hsl(0, 0%, 13%)',
}
